import axios from "axios"
const instance = axios.create({
	baseURL: process.env.VUE_APP_API_URL || "https://tal.lipn.univ-paris13.fr/morfetik2/api/",
	headers: {
		"Content-Type": "application/json",
	},
})
export default instance
